<template>
  <div class="table-container">
    <h3 style="margin-bottom: 16px; color: #333;">相关信息</h3>
    <div style="line-height: 1.8; color: #666;">
      <div class="qr-codes-row">
        <div class="qr-item">
          <h4 style="margin-bottom: 16px; color: #333;">小程序版本LOF套利信息查询工具</h4>
          <div class="qr-title">小程序（因恶意举报，暂时关闭实时数据显示）</div>
          <div class="qr-title">重新开启群内通知</div>
          <img :src="xiaochengxuImg" alt="小程序二维码" class="qr-image">
        </div>
        <div class="qr-item">
          <h4 style="margin-bottom: 16px; color: #333;">相关微信公众号，更多搞钱秘籍</h4>
          <img :src="gongzhonghaoImg" alt="公众号二维码" class="qr-image">
        </div>
        <div class="qr-item">
          <h4 style="margin-bottom: 16px; color: #333;">联系作者加入交流群</h4>
          <img :src="wxImg" alt="微信二维码" class="qr-image">
        </div>
      </div>
      <div class="pay-codes-row">
        <div class="pay-item">
        <h4 style="margin-bottom: 16px; color: #333; margin-top: 20px;">更新不易,谢谢打赏</h4>
          <img :src="wxpayImg" alt="微信收款二维码" class="qr-image">
        </div>
        <div class="pay-item">
        <h4 style="margin-bottom: 16px; color: #333; margin-top: 20px;">更新不易,谢谢打赏</h4>
          <img :src="zfbpayImg" alt="支付宝收款二维码" class="qr-image">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InfoPage',
  data() {
    return {
      xiaochengxuImg: require('@/assets/xiaochengxu.jpg'),
      gongzhonghaoImg: require('@/assets/gongzhonghao.jpg'),
      wxImg: require('@/assets/wx.jpg'),
      wxpayImg: require('@/assets/wxpay.png'),
      zfbpayImg: require('@/assets/zfbpay.png')
    }
  }
}
</script>

<style scoped>
.table-container {
  background: #fff;
  padding: 16px;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.qr-codes-row {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  margin-bottom: 20px;
}

.qr-item {
  flex: 1;
  min-width: 200px;
  text-align: center;
}

.qr-image {
  max-width: 100%;
  width: 200px;
  height: auto;
  display: block;
  margin: 0 auto;
}

.pay-codes-row {
  display: flex;
  gap: 20px;
  justify-content: center;
  flex-wrap: wrap;
}

.pay-item {
  text-align: center;
}

@media (max-width: 768px) {
  .qr-codes-row {
    flex-direction: column;
  }
  
  .qr-item {
    min-width: 100%;
  }
  
  .pay-codes-row {
    flex-direction: column;
    align-items: center;
  }
}
</style>

